import Box from "ds/components/Box";
import UserGroupStatusBadge from "views/Account/Settings/IdpGroup/UserGroupStatusBadge";

import { CellComponentProps } from "../types";

type UserIdpGroupsListItemStatusCellProps = CellComponentProps;

const UserIdpGroupsListItemStatusCell = ({ mappedGroup }: UserIdpGroupsListItemStatusCellProps) => {
  if (!mappedGroup) {
    return null;
  }

  return (
    <Box>
      <UserGroupStatusBadge status={mappedGroup?.status} />
    </Box>
  );
};

export default UserIdpGroupsListItemStatusCell;
